import { usePersistedSessionState } from "@edreamsodigeo/frontend-core";

const useHasFlightDiscountSelectedBySessionStorage = ():
  | boolean
  | undefined => {
  const [selectionData] = usePersistedSessionState("flightSelectionData");
  // TODO: temporary solution to read the value without re-writing it in the session storage
  // usePersistedSessionState replaces the value in session storage but cached not updated value because of different instances where we call usePersistedSessionState
  // need to introduce a way to read the value from session storage without using usePersistedSessionState
  const subscriptionSelectedOnContinue = sessionStorage.getItem(
    "subscriptionSelectedOnContinue",
  );

  return (
    !selectionData?.data?.priceWithoutDiscountSelected ||
    subscriptionSelectedOnContinue === "prime"
  );
};

export default useHasFlightDiscountSelectedBySessionStorage;
